import CenterWrap from 'components/CenterWrap';
import React from 'react';
import { Link } from 'react-router-dom';

import { LAST_UPDATED_LABEL, legalDocuments } from './content';
import { DocumentWrap, Meta } from './styles';

export default function LegalDocument({ documentKey }) {
  const document = legalDocuments[documentKey];

  if (!document) {
    return null;
  }

  return (
    <CenterWrap>
      <DocumentWrap>
        <Link className="backLink" to="/termos-de-uso">
          Voltar para documentos legais
        </Link>
        <h1>{document.title}</h1>
        <Meta>Última atualização: {LAST_UPDATED_LABEL}</Meta>
        <div dangerouslySetInnerHTML={{ __html: document.html }} />
      </DocumentWrap>
    </CenterWrap>
  );
}
